import React, { useEffect, useState } from 'react';
import './Leavemanagement.css';
import HrDashboardAside from './HrDashboardAside';

const LeaveManagement = () => {
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const fetchLeaveRequests = async () => {
    setLoading(true);
    setMessage('');
    try {
      const response = await fetch('https://cleezoclass.com:8443/api/get-leave-requests');
      if (!response.ok) throw new Error('Failed to fetch leave requests');
      const data = await response.json();
      setLeaveRequests(data);
    } catch (error) {
      console.error(error.message);
      setMessage('Error fetching leave requests.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toISOString().split('T')[0];
  };

  const submitResponse = async (empId, response, leaveType, startDate, endDate, empName, designation) => {
    try {
      if (!response) {
        alert('Please select a response before submitting.');
        return;
      }
  
      const requestBody = {
        empId,
        response,
        leave_type: leaveType,
        start_date: formatDate(startDate),  // Ensure format is YYYY-MM-DD
        end_date: formatDate(endDate),
        empName,
        designation,
      };
  
      console.log('Sending Request Body:', requestBody); // Debugging
  
      setLoading(true);
  
      const res = await fetch('https://cleezoclass.com:8443/api/submit-response', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody),
      });
  
      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || 'Failed to submit response.');
      }
  
      const result = await res.json();
      console.log('Response from API:', result); // Debugging
  
      setMessage(result.message);
  
      // Update UI after success
      setLeaveRequests((prevRequests) =>
        prevRequests.map((req) =>
          req.empId === empId && req.start_date === startDate && req.end_date === endDate
            ? { ...req, response }
            : req
        )
      );
    } catch (error) {
      console.error('Error submitting response:', error.message);
      setMessage('Error submitting response.');
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchLeaveRequests();
  }, []);

  return (
    <div className="leave-management-container mainBlock">
      <HrDashboardAside />
      <h2 className="leave-management-heading">Leave Management</h2>
      {loading && !leaveRequests.length && <p className="leave-management-loading-msg">Loading leave requests...</p>}
      {message && <p className="leave-management-message">{message}</p>}

      <div className="leave-management-table-container">
        <table className="table-leave-table">
          <thead>
            <tr className="table-leave-header">
              <th>Employee ID</th>
              <th>Employee Name</th>
              <th>Designation</th>
              <th>Leave Type</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Response</th>
            </tr>
          </thead>
          <tbody>
            {leaveRequests.length > 0 ? (
              leaveRequests.map((request, index) => (
                <tr key={`${request.empId}-${index}`}>
                  <td>{request.empId}</td>
                  <td>{request.empName || 'N/A'}</td>
                  <td>{request.designation || 'N/A'}</td>
                  <td>{request.leave_type || 'General'}</td>
                  <td>{formatDate(request.start_date)}</td>
                  <td>{formatDate(request.end_date)}</td>
                  <td className="leave-management-response-column">
                    {request.response === 'approved' ? (
                      <span className="leave-management-status approved">✅ Leave Approved</span>
                    ) : request.response === 'rejected' ? (
                      <span className="leave-management-status rejected">❌ Leave Rejected</span>
                    ) : (
                      <div className="button-group">
                        <button
                          className="leave-management-button approve"
                          onClick={() =>
                            submitResponse(
                              request.empId,
                              'approved',
                              request.leave_type,
                              request.start_date,
                              request.end_date,
                              request.empName,
                              request.designation
                            )
                          }
                        >
                          Approve
                        </button>
                        <button
                          className="leave-management-button reject"
                          onClick={() =>
                            submitResponse(
                              request.empId,
                              'rejected',
                              request.leave_type,
                              request.start_date,
                              request.end_date,
                              request.empName,
                              request.designation
                            )
                          }
                        >
                          Disapprove
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="leave-management-no-data">No leave requests found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LeaveManagement;
